module.exports = __webpack_public_path__ + "img/LTU.4e37e48a.svg";